import { render, staticRenderFns } from "./profile-uncompleted-task-action.vue?vue&type=template&id=340db4cf"
import script from "./profile-uncompleted-task-action.vue?vue&type=script&lang=js"
export * from "./profile-uncompleted-task-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports